// Venue-type helpers shared across the member app + admin. Keep these in one
// place so new booking verticals (WELLNESS, and whatever comes next) stay in
// sync with the backend predicate in src/lib/venue.ts (`hasSessionBooking`).

// Venue types that offer time-slot / session booking: STUDIO (coworking desks)
// and WELLNESS (sauna / wellness sessions). Both share the same booking engine;
// they differ only in the words shown to members (see bookingWords).
export function isBookingVenue(archetype: string | null | undefined): boolean {
  return archetype === "STUDIO" || archetype === "WELLNESS";
}

export type BookingWords = {
  /** lowercase noun for a single booking, e.g. "desk" / "session" */
  noun: string;
  /** capitalised noun, e.g. "Desk" / "Session" */
  Noun: string;
  /** primary CTA, e.g. "Book a Desk" / "Book a session" */
  cta: string;
  /** short subtitle under a booking heading */
  subtitle: string;
  /** heading for the member's booking list */
  listHeading: string;
};

// The vocabulary a venue uses for bookings. WELLNESS reads as sauna/wellness
// "sessions"; everything else (STUDIO) keeps the coworking "desk" language.
export function bookingWords(archetype: string | null | undefined): BookingWords {
  if (archetype === "WELLNESS") {
    return {
      noun: "session",
      Noun: "Session",
      cta: "Book a session",
      subtitle: "Reserve your spot",
      listHeading: "Sessions you've booked",
    };
  }
  return {
    noun: "desk",
    Noun: "Desk",
    cta: "Book a Desk",
    subtitle: "Reserve your workspace for the day",
    listHeading: "Studio sessions you've booked",
  };
}
